import {useGetAlphaCatalogueQuery} from '@dms/api/core';
import {browserStorageKey} from '@dms/config';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {useVehicleCatalogueLogic, VehicleCatalogueReturnType} from 'features/vehicle-catalogue';

import {resolveCatalogueLanguage} from './resolveCatalogueLanguage';

export function useVehicleCatalogue(
  type: string | Nullish,
  shouldSortByLabel = true
): VehicleCatalogueReturnType {
  const language = resolveCatalogueLanguage(
    localStorage.getItem(browserStorageKey.LAST_KNOWN_LANGUAGE),
    i18n.resolvedLanguage
  );
  const {data, isError, isLoading} = useGetAlphaCatalogueQuery({
    lang: language,
  });

  return useVehicleCatalogueLogic({data, isError, isLoading, type, shouldSortByLabel});
}
